import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DashboardPizzaRQ } from './model/DashboardPizzaRQ';
import { Observable } from 'rxjs';
import { DashboardPizzaRS } from './model/DashboardPizzaRS';
import { endpoints } from '../../../environments/endpoint';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AppDashboardPizzaWorkaroundService {

  constructor(private http: HttpClient) { }

  convertDataIsoPizzaWork(request: DashboardPizzaRQ): void {
    let arrayStringPizzaWork: string[] = [];
    arrayStringPizzaWork = request.dtVoo.split('/');
    request.dtVoo = arrayStringPizzaWork[2]
                    + '-' +  arrayStringPizzaWork[1]
                      + '-' +  arrayStringPizzaWork[0]
                        + 'T00:00:00';
  }

  getDataByDate(requestPizzaWork: DashboardPizzaRQ): Observable<DashboardPizzaRS[]> {
    if (!requestPizzaWork.dtVoo.includes('T')) {
      this.convertDataIsoPizzaWork(requestPizzaWork);
    }
    let params1 = new HttpParams().set('flightBeginDate', requestPizzaWork.dtVoo);
    return this.http.get<DashboardPizzaRS[]>(endpoints.REST_GET_WORKAROUND_PIZZA+"?"+params1, httpOptions);
  }
}
